import React, { useState, useEffect, useRef } from 'react';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';
import Button from '@sdk/components/ui/buttons/Button';
import gettext from '@sdk/lang/gettext';
import Picker from '@sdk/components/forms/Picker';
import TextareaAutoheight from '@sdk/components/forms/TextareaAutoheight';
import FieldLabel from '@sdk/components/forms/components/FieldLabel';

import { ButtonContainer } from '@web/components/survey/ButtonContainer';
import {
  ACTIONABLE_STEPS_COUNT,
  NpsSteps,
  RATING_INFLUENCE_OPTIONS,
  STEPS_CONFIG,
  OTHER_INFLUENCE_KEY,
} from '@web/components/npsScore/constants';
import SurveyStep from '@web/components/survey/SurveyStep';

import { Influence } from '../NpsSurveyProvider/npsSurveyProvider.types';

import { InfluenceStepContainer } from './ratingInfluenceStep.styles';
import { useRatingInfluenceStep } from './ratingInfluence.hooks';

type Props = {
  submitStep: () => void;
};

export const RatingInfluenceStep = ({ submitStep }: Props) => {
  const currentStep = STEPS_CONFIG[NpsSteps.influence];
  const {
    commentInputRef,
    influence,
    isCommentVisible,
    isValid,
    setInfluence,
    setInfluenceComment,
  } = useRatingInfluenceStep();

  return (
    <SurveyStep
      subtitle={currentStep.subtitle}
      number={currentStep.number}
      count={ACTIONABLE_STEPS_COUNT}>
      <InfluenceStepContainer>
        <Picker
          options={RATING_INFLUENCE_OPTIONS}
          placeholder={gettext('Please select')}
          value={influence}
          onChange={(value: Influence): void => setInfluence(value)}
          showMenuAbove
        />

        {isCommentVisible && (
          <div>
            <FieldLabel
              label={gettext('Please specify')}
              htmlFor="other-influence-comment"></FieldLabel>
            <TextareaAutoheight
              id="other-influence-comment"
              ref={commentInputRef}
              placeholder={gettext('Type your comment...')}
              onChange={(e): void => setInfluenceComment(e.target.value)}
              maxLength={256}
            />
          </div>
        )}
      </InfluenceStepContainer>

      <ButtonContainer>
        <Button disabled={!isValid} buttonType={ButtonType.primary} onClick={submitStep}>
          {gettext('Next')}
        </Button>
      </ButtonContainer>
    </SurveyStep>
  );
};
